import React, { useState } from "react";
import TeamGoals from "./TeamGoals";
import TeamProgress from "./TeamProgress";

const TodayTeamTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  return (
    <>
      <div className="bg-white rounded-[20px]  shadow-todays_workflow_box_shadow overflow-x-hidden">
        <div className="flex w-full justify-between">
          <button
            className={`px-4 py-4 w-full  text-xs xl:text-sm 3xl:text-base font-semibold ${
              activeTab === 0
                ? "border-b-2 border-primary text-primary"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(0)}>
            Today teams goals
          </button>
          <button
            className={`px-4 py-4 w-full text-xs xl:text-sm 3xl:text-base font-semibold ${
              activeTab === 1
                ? "border-b-2 border-primary text-primary"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(1)}>
            Today teams progress
          </button>
        </div>
        {activeTab === 0 && (
          <div className="mt-5">
            <TeamGoals />
          </div>
        )}
        {activeTab === 1 && (
          <div className="mt-5">
            <TeamProgress />
          </div>
        )}
      </div>
    </>
  );
};

export default TodayTeamTabs;
